<template>
  <div class="modern-radio-tabs">
    <label class="modern-radio-tabs--label">{{ label }}</label>
    <div class="modern-radio-tabs--field field has-addons">
      <b-radio-button
        v-for="item in items"
        v-model="innerValue"
        :native-value="item[valueKey]"
        :key="item[valueKey]"
        :class="{ 'is-active': item[valueKey] === value }"
        class="modern-radio-tabs--button"
      >
        {{ item[displayValueKey] }}
      </b-radio-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModernRadioTabs',
  props: {
    label: {
      type: String,
      default: 'Radio tabs',
    },
    items: {
      type: Array,
      default: () => ({}),
    },
    value: {
      default: null,
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    displayValueKey: {
      type: String,
      default: 'name',
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
  },
};
</script>


<style lang="stylus">
@require "../../assets/style/variables.styl";

.modern-radio-tabs
  @media(max-width:499px)
    width 100%
  &--label
    font-size 16px;
    font-weight 400;
    line-height 24px;
    color #969ea2
    margin-bottom 8px
    display block
  &--field
    flex-wrap wrap
  &--button
    @media(max-width:499px)
      flex-grow 1
      flex-shrink 0
    & label
      height 48px
      padding 8px 16px
    &.is-active
      z-index 4
      & label,
      & label:hover,
      & label:focus,
      & label.is-focused
        background-color enh-color-green-light
        border-color enh-color-green
        color enh-color-black
        box-shadow none !important
    &.is-primary
      z-index 4
      & label
        background-color enh-color-green-light
        border-color enh-color-green
        color enh-color-black
        box-shadow none
</style>
